import { useState } from 'react'
import { App, Button, Form, Input, Modal } from 'antd'
import { deleteMemberAccount, memberKeys, updateCurrentMember, useCurrentMember } from '@/entities/member'
import { queryClient } from '@/app/query-client'

type MemberProfileModalProps = {
  open: boolean
  onClose: () => void
  onAccountDeleted: () => Promise<void>
}

export function MemberProfileModal({ open, onClose, onAccountDeleted }: MemberProfileModalProps) {
  const { message, modal } = App.useApp()
  const { data: member } = useCurrentMember()
  const [nickname, setNickname] = useState<string>()
  const [saving, setSaving] = useState(false)

  const saveProfile = async () => {
    setSaving(true)
    try {
      await updateCurrentMember({ nickname: nickname ?? member?.nickname ?? '', avatarFileId: member?.avatarFileId ?? null })
      await queryClient.invalidateQueries({ queryKey: memberKeys.me() })
      void message.success('资料已更新')
    } catch (error) {
      void message.error(error instanceof Error ? error.message : '资料更新失败')
    } finally {
      setSaving(false)
    }
  }

  const deleteAccount = () => {
    let password = ''
    modal.confirm({
      title: '注销当前账号？',
      content: <Input.Password placeholder="请输入当前密码确认" onChange={(event) => { password = event.target.value }} />,
      okText: '确认注销',
      okButtonProps: { danger: true },
      cancelText: '取消',
      onOk: async () => {
        if (!password) throw new Error('请输入当前密码')
        await deleteMemberAccount(password)
        await onAccountDeleted()
      },
    })
  }

  return <Modal open={open} title="个人资料" width={560} footer={<Button onClick={onClose}>关闭</Button>} onCancel={onClose} afterClose={() => setNickname(undefined)}>
    <Form layout="vertical">
      <Form.Item label="登录邮箱"><Input value={member?.email} disabled /></Form.Item>
      <Form.Item label="昵称"><Input value={nickname ?? member?.nickname ?? ''} maxLength={64} onChange={(event) => setNickname(event.target.value)} /></Form.Item>
      <Button type="primary" loading={saving} onClick={() => void saveProfile()}>保存资料</Button>
    </Form>
    <section className="member-danger-zone">
      <div><b>注销账号</b><p>注销后账号及相关数据将无法恢复，请谨慎操作。</p></div>
      <Button danger onClick={deleteAccount}>注销账号</Button>
    </section>
  </Modal>
}
